import { handleErrors } from './ErrorActions';
import {
  getAllUINotifications,
  getNewUINotifications,
  setUINotificationUserAction,
} from '../api/notifications';
import { NOTIFICATION_UPDATE_INTERVAL } from '../constants/NotificationConstants';
import { preprocessNotifications } from '../utils/notificationUtils';

export const ADD_NOTIFICATIONS = 'ADD_NOTIFICATIONS';
export const UPDATE_NOTIFICATION_ACTIONS = 'UPDATE_NOTIFICATION_ACTIONS';

export const addNotifications = (notifications) => ({
  type: ADD_NOTIFICATIONS,
  payload: {
    notifications,
  },
});

export const updateNotificationActions = (notificationsActions) => ({
  type: UPDATE_NOTIFICATION_ACTIONS,
  payload: {
    notificationsActions,
  },
});

export const handleNotificationResponse = (response, dispatch) => {
  if (!response.hasError) {
    const { Notifications: notifications = [] } = response;

    if (notifications.length) {
      const preprocessedNotifications = preprocessNotifications(notifications);
      dispatch(addNotifications(preprocessedNotifications));
    }
  } else {
    dispatch(handleErrors(response.errors));
    return;
  }
};

export const getNewNotifications = (timer) => async (dispatch, getState) => {
  const { auth, notifications, networkStatus } = getState();
  const { logged_in: isLoggedIn, isTokenExpired } = auth;

  if (timer && (!isLoggedIn || isTokenExpired || !networkStatus.isOnline)) {
    clearInterval(timer);
    return;
  }

  if (!notifications.length) {
    const notificationsResponse = await getAllUINotifications();

    handleNotificationResponse(notificationsResponse, dispatch);
  } else {
    // notifications are already sorted in store by createdDate in desc order
    // so the first one is always the newest
    const latestNotificationDate = notifications[0].createdDate;

    const newNotificationResponse = await getNewUINotifications(latestNotificationDate);

    handleNotificationResponse(newNotificationResponse, dispatch);
  }
};

export const startNotificationPullingTimer = () => (dispatch) => {
  //start pulling system to get new notification every period of time
  const timer = setInterval(() => {
    dispatch(getNewNotifications(timer));
  }, NOTIFICATION_UPDATE_INTERVAL);
};

export const startNotificationPullingSystem = () => async (dispatch, getState) => {
  const { isOnline } = getState().networkStatus;

  if (!isOnline) {
    return;
  }

  const notificationsResponse = await getAllUINotifications();

  handleNotificationResponse(notificationsResponse, dispatch);

  dispatch(startNotificationPullingTimer());
};

export const handleNotificationActions = (notificationsActions) => async (dispatch) => {
  const notificationUserActionResponse = await setUINotificationUserAction(notificationsActions);

  if (!notificationUserActionResponse.hasError) {
    dispatch(updateNotificationActions(notificationsActions));
  } else {
    dispatch(handleErrors(notificationUserActionResponse.errors));
  }
};
